export default __webpack_public_path__ + "static/media/about2.1cfb9ef6.jpg";